module.exports = __webpack_public_path__ + "img/img (9).65981fd4.png";